export default "/packs/images/Char~e21869aed1d8291531eac67aff373bd7.jpg";